// extracted by mini-css-extract-plugin
module.exports = {"baseClass":"Card_baseClass__1frXs"};